
import { globalApiHandler } from "../../services/services";
import { isCounterParty } from "../../components/Common/CheckAuthorization";

export const getReportsData = (params) => {
    let url = `/ntrac/report/filter?${params}`
    if(isCounterParty()){
    url = `/ntrac/report/counterparty/filter?${params}`
    }
    return dispatch => {
        globalApiHandler(url, 'get', {}, dispatch).then((response) => {
            const data = response.data
            console.log(data,'data')
            dispatch({ type: 'FILTERED_REPORTS_LIST', data: data.data })
            // dispatch({type: 'SERVER_SUCCESS', data: response.data})
            return true
        }).catch((err)=>{
            dispatch({type: 'SERVER_ERROR', data: err.data})
        })
    }
}


// WEBPACK FOOTER //
// ./src/modules/reports/action.js